import VoucherImport from "./voucher-import.page";

export default VoucherImport;
